var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("entity.organization")))]),_c('department-boxes'),_c('process-boxes'),_c('datasource-boxes'),_c('data-category-boxes'),_c('data-boxes'),_c('datasubject-boxes'),_c('datasubject-boxes-for-datasource')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }